export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ./~/_@babel_runtime@7.14.8@@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 240
// module chunks = 38